import classes from "./mixedGrid.module.scss";
import { ReactNode } from "react";

export interface MixedGridProps {
    children: ReactNode;
}

const MixedGrid = ({ children }: MixedGridProps) => {
    return (
        <div className={classes.mixedGrid} data-testid={"mixedGrid"}>
            {children}
        </div>
    );
};

export default MixedGrid;
